/**
 * Which build this is.
 *
 * `__APP_VERSION__` is replaced at build time by Vite with the contents of the
 * repo-root VERSION file (`1.13.1#082326` — number, then the date it was cut).
 * Both halves matter in Preferences: the number says what the code is, the date
 * says whether the bundle a browser is actually running is the one that was
 * just deployed. A stale service worker has answered that question wrongly
 * before, and guessing from behaviour is slower than reading it off the screen.
 *
 * The `typeof` guard is what lets this module be imported outside a Vite build
 * — the client test suite runs in plain node, where the define does not exist
 * and a bare reference would be a ReferenceError rather than a missing string.
 */
export const APP_VERSION =
  typeof __APP_VERSION__ === 'string' && __APP_VERSION__ ? __APP_VERSION__ : 'dev';

/** Just the release number, for anywhere the build date would be noise. */
export const APP_RELEASE = APP_VERSION.split('#')[0];
